// GeneralInfos.jsx
import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../components/Sidebar";
import OrgFileCard from "../components/OrgFileCard";
import WeeklyMenuTable from "../components/WeeklyMenuTable";
import MealPreferencesGrid from "../components/Mealpreferences";

const API = process.env.REACT_APP_API_URL;

export default function GeneralInfos() {
  const [filePath, setFilePath] = useState(null);
  const [fileId, setFileId] = useState(null);
  const [menu, setMenu] = useState(null);

  // NEW: export trigger ref from the grid
  const exportRef = useRef(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${API}/orgfiles/latest?header=Essensplan&include_menu=true`,
          { credentials: "include" }
        );
        if (!res.ok) return;
        const payload = await res.json();
        const item = payload.item ?? null;

        if (item) {
          setFileId(item.id);
          setFilePath(item.path);
        }

        const latestMenu = payload.menu ?? item?.menu_json ?? null;
        if (latestMenu) setMenu(latestMenu);
      } catch (_) {}
    })();
  }, []);

  return (
    <div className="flex min-h-screen bg-[#cdeaff]">
      <Sidebar active="infos" />
      <main className="flex-1 px-0 pt-6 pb-0">
        <div className="w-full h-full rounded-tl-xl border border-black/10 bg-white/60 p-6 backdrop-blur">
          <div className="flex items-center justify-between">
            <h1 className="text-3xl font-semibold text-gray-900">
              Allgemeine Infos
            </h1>
          </div>

          <div className="mt-6">
            <OrgFileCard
              header="Essensplan"
              fileId={fileId}
              filePath={filePath}
              onChangeFilePath={setFilePath}
              onChangeFileId={setFileId}
              metaTitle="Essensplan"
              metaDescription="-"
              onMenuParsed={setMenu}
            />
          </div>

          <WeeklyMenuTable menu={menu} />

          {/* Section Header for Meal Preferences */}
          <div className="flex items-center justify-between mt-12 mb-3">
            <h3 className="text-xl font-semibold text-gray-900">
              Essenspräferenzen (Woche)
            </h3>
          </div>

          {/* Pass a setter so the child can register its export handler */}
          <MealPreferencesGrid registerExport={(fn) => (exportRef.current = fn)} />
        </div>
      </main>
    </div>
  );
}
